import { useT } from "react-polyglot-hooks"
import * as PropTypes from "prop-types"
import { useContext } from "react"
import { applyFilters } from "helpers/filterCars"
import { RentingContext } from "scenes/RentingScene/RentingContext"
import useFilteredOptions from "hooks/useFilteredOptions"
import Selector from "../Selector"
import Typography from "../../../styled/Typography"

const months = [24, 36, 48, 60]

export default function DurationSelector({ field, value, show, handleChange, label }) {
  const t = useT()
  const { cars } = useContext(RentingContext)

  const options = useFilteredOptions(field, () =>
    months
      .map(month => ({ value: month, label: t("common.duration", { smart_count: month }) }))
      .filter(option => applyFilters(cars, { [field]: option.value }).length > 0)
  )

  if (!show) return null

  return (
    <>
      {label && (
        <Typography el="label" className="mb-2">
          {label}
        </Typography>
      )}
      <Selector
        field={field}
        initialValue={value}
        options={options}
        handleChange={handleChange}
        multiple
        col={{ xs: 3, lg: 6 }}
      />
    </>
  )
}

DurationSelector.defaultProps = { show: true, label: null, field: "duration", value: [] }

DurationSelector.propTypes = {
  value: PropTypes.arrayOf(PropTypes.number),
  show: PropTypes.bool,
  label: PropTypes.string,
  field: PropTypes.string,
  handleChange: PropTypes.func.isRequired
}
